import {Injectable} from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {ReportType} from '../models/report-type.model';
import {CALENDAR_MONTH_OFFSET, FLEXIBLE_REPORT_TAB} from './report-datepicker.constants';
import {ReportDatepickerSpecialRequestCoordinator} from './report-datepicker-special-request.coordinator';
import {ReportDatepickerStandardRequestCoordinator} from './report-datepicker-standard-request.coordinator';
import {
  ReportDatepickerWorkflowView
} from './report-datepicker.types';
import {ReportProgressCoordinator} from './report-progress.coordinator';

@Injectable()
export class ReportDatepickerReportCoordinator {
  private destroyed = false;

  constructor(
    private standardRequests: ReportDatepickerStandardRequestCoordinator,
    private specialRequests: ReportDatepickerSpecialRequestCoordinator,
    private progress: ReportProgressCoordinator
  ) {
  }

  submitReportRequest(view: ReportDatepickerWorkflowView): void {
    if (!view.isLoaded) {
      return;
    }
    const tracked = this.shouldTrackPersonalReport(view);
    if (tracked) {
      view.isLoaded = false;
      this.progress.startPersonal(
        view, (successful: boolean) => this.finishPersonalProgress(view, successful));
    }
    try {
      this.sendRequest(view);
    } catch (error) {
      this.cancelPendingPersonalReport(view, tracked);
      throw error;
    }
  }

  sendRequest(view: ReportDatepickerWorkflowView): void {
    const context = this.standardRequests.prepare(view);
    if (!context || this.specialRequests.dispatch(view, context)) {
      return;
    }
    this.standardRequests.dispatch(view, context);
  }

  startGroupReportGeneration(
    view: ReportDatepickerWorkflowView, from: string, to: string
  ): void {
    this.standardRequests.startGroup(view, {from: from, to: to});
  }

  destroy(): void {
    if (this.destroyed) {
      return;
    }
    this.destroyed = true;
    this.progress.destroy();
    this.standardRequests.destroy();
  }

  cancelGroupOnDateChange(view: ReportDatepickerWorkflowView): void {
    if (view.reportType === ReportType.BY_GROUP) {
      this.standardRequests.cancelGroup(view);
    }
  }

  private shouldTrackPersonalReport(view: ReportDatepickerWorkflowView): boolean {
    if (view.reportType !== ReportType.BY_USER && view.reportType !== ReportType.BY_USER_DEP) {
      return false;
    }
    const fromDate = this.date(view.from);
    const toDate = this.date(view.to);
    return view.currentTab === FLEXIBLE_REPORT_TAB || toDate >= fromDate;
  }

  private cancelPendingPersonalReport(
    view: ReportDatepickerWorkflowView, tracked: boolean
  ): void {
    if (tracked) {
      this.progress.cancelPersonal(view);
      view.isLoaded = true;
    }
  }

  private finishPersonalProgress(
    view: ReportDatepickerWorkflowView, successful: boolean
  ): void {
    if (successful) {
      this.progress.complete(view);
      return;
    }
    this.progress.fail(view);
    view.isLoaded = true;
  }

  private date(value: NgbDateStruct): Date {
    return new Date(value.year, value.month - CALENDAR_MONTH_OFFSET, value.day);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-report.coordinator.ts